<template>
  <DownloadsDocumentsDocumentCenterProductList />
</template>

<script setup lang="ts">
import { useDownloadStore } from '~/stores/downloadStore/downloadStore';

const downloadStore = useDownloadStore();

// reset downloader center as the store is used in multiple places (pdp or
// standalone).
// We can not reset the store (via $reset) as in the standalone version
// the route for the modal triggers a unmount and mount of all components.
// @see https://gcp.baslerweb.com/jira/browse/DBP-1237
downloadStore.$patch({
  context: 'documentCenter',
  staticFilters: {},
  documentationLink: undefined
});
</script>
